import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, Button, Checkbox, Row, Col, notification, Tabs, Radio, Table, Divider, Spin, Image, Popconfirm, InputNumber, DatePicker, Tooltip } from 'antd';
import { FileImageOutlined, AudioOutlined, DeleteOutlined, VideoCameraOutlined, CloseOutlined } from '@ant-design/icons';
import StudentLoader from '../common/student-loader';
import BatchLoader from '../common/batch-loader';
import GroupLoader from '../common/group-loader';
import StreamLoader from '../common/stream-loader';
import ClassDivisionLoader from '../common/class-division-loader';
import ResourceLevel from '../common/resource-level-loader';
import LabQuestionFilter from '../utils/lab-question-filters';
import { projectStacks, global_var } from '../../services/cs-lab-config';
import { isEqual } from 'lodash';
import { saveMaterialToResource, fileUpload, assignLabQuestion, fetchLabQuestionResource, servUploadFileToCloud} from '../../services/ide-apis';
import { getIdeProjectTypeMetaData, trackEvent } from '../utils/util-functions';
import TinyMCEEditor from '../common/tinymce-editor-loader';
import dayjs from 'dayjs';
import AiQuestions from './ai-questions';
import { ReactComponent as AiIconRed } from '../../assets/logos/ai icon red.svg';
import "./create-assignment-modal.css"
import { ReactComponent as AiIconWhite } from '../../assets/logos/ai icon white.svg';
import ParaphraseAi from "../paraphraser/paraphrase-ai-modal";

const { TabPane } = Tabs;

const CreateAssignment = ({ visible, onCancel, onCreate, loading, hideClassFilter, hideStreamFilter }) => {

    const [form] = Form.useForm();
    const { Option } = Select;
    const [assignTo, setAssignTo] = useState("");
    const [moreOptionChecked, setMoreOptionChecked] = useState(false);
    const [dueDateChecked, setDueDateChecked] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState(null);
    const [selectedBatch, setSelectedBatch] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState([]);
    const [selectedClassDivision, setSelectedClassDivision] = useState([]);
    const [selectedClassDivisionStream, setSelectedClassDivisionStream] = useState([]);
    const [singleClassDivisionStream, setSingleClassDivisionStream] = useState([]);
    const [image, setImage] = useState([]);
    const [audio, setAudio] = useState([]);
    const [imagePreview, setImagePreview] = useState([]);
    const [audioPreview, setAudioPreview] = useState([]);
    const [video, setVideo] = useState([]);
    const [videoPreview, setVideoPreview] = useState([]);
    const [buttonText, setButtonText] = useState("Assign");
    const [buttonLoader, setButtonLoader] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState('createNewQuestion');
    const [labQuestions, setLabQuestions] = useState([]);
    const [previousFilters, setPreviousFilters] = useState([]);
    const [selectedLabQuestions, setSelectedLabQuestions] = useState([]);
    const [selectedCurentQuestion, setSelectedCurentQuestion] = useState(null);
    const [imageLoading, setImageLoading] = useState(false);
    const [audioLoading, setAudioLoading] = useState(false);
    const [videoLoading, setVideoLoading] = useState(false);
    const [questionDescription, setQuestionDescription] = useState('');
    const [selectedDueDate, setSelectedDueDate] = useState("");
    const [aiProjectType, setAiProjectType] = useState("");
    const [formValues, setFormValues] = useState({
        aiQuestionTitle: '',
        aiQuestionDescription: ''
    });
    const [selectedProject, setSelectedProject] = useState('default');
    const [grade, setGrade] = useState(null);
    const [topic, setTopic] = useState('');
    const [additionalInfo, setAdditionalInfo] = useState('');
    const [paraphrasedDescription, setParaphrasedDescription] = useState('');
    const [aiQuestionDescriptions, setAiQuestionDescriptions] = useState('');

    const handleMoreOptionChange = (e) => {
        setMoreOptionChecked(e.target.checked);
    };
    const handleDueDateChange = (e) => {
        setDueDateChecked(e.target.checked);
    };

    const disabledDate = (current) => {
        // Disable dates before today
        const today = dayjs().startOf('day');
        return current && dayjs(current).isBefore(today, 'day');
    };

    const columns = [
        {
            title: 'Select',
            dataIndex: 'key',
            className:'poppins-regular',
            render: (text, record) => (
                <Checkbox
                    onChange={(e) => handleRowSelection(e, record)}
                    checked={selectedLabQuestions.some((question) => question.fkActivityId === record._id)}
                />
            ),
        },
        {
            title: 'Title',
            dataIndex: 'title',
            className:'poppins-regular',
        },
        {
            title: 'Type',
            dataIndex: 'subSubjectName',
            className:'poppins-regular',
        },
    ];

    const handleRowSelection = (e, record) => {
        setSelectedCurentQuestion(record);
        const selectedKey = record._id; // Use a unique identifier as the key

        setSelectedLabQuestions((prevSelectedQuestions) => {
            const updatedSelectedQuestions = [...prevSelectedQuestions];

            if (e.target.checked) {
                // Add the selected key and related information to the array if checked
                const newSelectedQuestion = {
                    fkActivityId: selectedKey,
                    activityName: record.title, // Use the actual property from the record object
                };
                // Check if projectType exists and add it to the new object
                if (record.projectType) {
                    newSelectedQuestion.projectType = record.projectType;
                }
                updatedSelectedQuestions.push(newSelectedQuestion);
            } else {
                // Remove the selected key from the array if unchecked
                const index = updatedSelectedQuestions.findIndex(
                    (question) => question.fkActivityId === selectedKey
                );
                if (index !== -1) {
                    updatedSelectedQuestions.splice(index, 1);
                }
            }

            return updatedSelectedQuestions;
        });
    };

    const handleFileChange = async (e, type) => {
        try {
            // Set loading to true when starting the file upload
            const files = e.target.files;
            if (type === 'video'){
                setVideoLoading(true)
                const videoMaxFileSize = 400;
                for (const selectedVideoObj of Array.from(files)) {
                    const fileSize = Math.ceil((selectedVideoObj.size / (1000 * 1000)));
                    if (fileSize < videoMaxFileSize) {
                        if (!selectedVideoObj.videoLink) {
                            try {
                                const uploadedResponse = await servUploadFileToCloud(selectedVideoObj);
                               
                                if (uploadedResponse.status === 'uploaded') {
                                    let uploadObjVideo = {
                                        "type": "video",
                                        "question": uploadedResponse.fileKey
                                    };
                                    let newVideo = {
                                        file: selectedVideoObj,
                                        preview: URL.createObjectURL(selectedVideoObj)
                                    };
                                
                                    setVideo(prevVideos => [...prevVideos, uploadObjVideo]);
                                    setVideoPreview(prevVideos => [...prevVideos, newVideo]);
                                } else {
                                    console.error('Unexpected upload status:', uploadedResponse.status);
                                }
                            } catch (error) {
                                console.error('Error during file upload process', error);
                            }
                        }
                    }
                }
                setVideoLoading(false)
            }else{

                let fileRequest = {};
                const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB
                const fileArray = Array.from(files);
    
                for (const file of fileArray) {
                    if (file.size > maxSizeInBytes) {
                        notification.error({
                            message: 'Error',
                            description: `File size exceeds the allowed limit (5 MB): ${file.name}. Please choose a file with a smaller size.`,
                        });
                        return;
                    }
                }
    
                // Handle multiple files
                for (const file of fileArray) {
                    if (type === 'image') {
                        setImageLoading(true);
                        fileRequest = {
                            "pathToBeSave": "labQuestionImages"
                        }
                    }
                    if (type === 'audio') {
                        setAudioLoading(true);
                        fileRequest = {
                            "pathToBeSave": "labQuestionAudio"
                        }
                    }
                        
                    const response = await fileUpload(file, fileRequest);
    
                    // Check if the file size exceeds the limit (in bytes)
                    if (response.status === 200 && response.data !== "") {
                        // Create a new image or audio object
                        if (type === "image") {
                            let uploadObjImage = {
                                "type": "image",
                                "question": 'labQuestionImages/' + response.data
                            };
                            let newImage = {
                                file: file,
                                preview: URL.createObjectURL(file)
                            };
                            setImage(prevImages => [...prevImages, uploadObjImage]);
                            setImagePreview(prevPreviews => [...prevPreviews, newImage]);
                        }
                        if (type === "audio") {
                            let uploadObjAudio = {
                                "type": "audio",
                                "question": 'labQuestionAudio/' + response.data
                            };
                            let newAudio = {
                                file: file,
                                preview: URL.createObjectURL(file)
                            };
                           
                            setAudio(prevAudios => [...prevAudios, uploadObjAudio]);
                            setAudioPreview(prevAudios => [...prevAudios, newAudio]);
                        }
                       
                    } else {
                        console.error("Service request failed:", response.statusText);
                    }
                }
            }
        } catch (error) {
            console.error("Error during service request:", error);
        } finally {
            setImageLoading(false);
            setAudioLoading(false);
            setVideoLoading(false);
        }
    };


    const handleResourceLevelChange = (value) => {
        setSelectedLevel(value.data);
    };
    const handleDatePickerChange = (value, dateString) => {
        setSelectedDueDate(dateString)
    };
        
    const handleStudentChange = (value) => {
        setSelectedStudent(value);
    };
    const handleBatchChange = (value) => {
        setSelectedBatch(value);
    };

    const handleClassDivision = (value) => {
        setSingleClassDivisionStream(prevState => ({
            ...prevState,
            ...value
        }));
    };


    const handleStreamChange = (value) => {
        setSingleClassDivisionStream(prevState => ({
            ...prevState,
            ...value
        }));
    };

    const handleGroupChange = (value) => {
        setSelectedGroup(value);
    };

    const assignLabQuestions = async (activityArr, values) => {
        setButtonText("Assigning Lab Question...");
        setButtonLoader(true);
        try {
            // Construct the request object for assigning lab questions
            let assignActivityObj = {
                "activitiesArr": activityArr,
                "crmId": global_var.roleMappingId,
                "teacherName": global_var.user_name,
            };
            if (selectedDueDate) {
                assignActivityObj.dueDate = selectedDueDate;
            }

            // Add assignment details based on the selected assignment method
            if (selectedBatch && selectedBatch.length > 0) {
                setSelectedStudent([]);
                setSelectedClassDivision([]);
                setSelectedGroup([]);
                setSelectedClassDivisionStream([]);
                assignActivityObj.batches = selectedBatch;
                assignActivityObj.studentMappings = [{
                    "type": "batches",
                    "batches": selectedBatch
                }];
            }

            if (selectedStudent && selectedStudent.length > 0) {
                setSelectedBatch([]);
                setSelectedClassDivision([]);
                setSelectedGroup([])
                setSelectedClassDivisionStream([]);
                assignActivityObj.studentMappings = [{
                    "type": "individual-students",
                    "individualStudents": selectedStudent
                }];
            }

            if (selectedGroup && selectedGroup.length > 0) {
                setSelectedStudent([]);
                setSelectedClassDivision([]);
                setSelectedBatch([]);
                setSelectedClassDivisionStream([]);
                assignActivityObj.groups = selectedGroup;
                assignActivityObj.studentMappings = [{
                    "type": "groups",
                    "groups": selectedGroup
                }];
            }

            if (selectedClassDivision && selectedClassDivision.length > 0) {
                setSelectedStudent([]);
                setSelectedBatch([]);
                setSelectedGroup([])
                setSelectedClassDivisionStream([]);
                const studentMapping = selectedClassDivision.map(item => ({
                    type: "class-division",
                    classId: item.fkClassId,
                    className: item.fkClassName,
                    ...(item.fkDivisionId && item.fkDivisionName ? {
                        divisionId: item.fkDivisionId,
                        divisionName: item.fkDivisionName
                    } : {}),
                }));


                assignActivityObj.studentMappings = studentMapping;
            }

            if(selectedClassDivisionStream && selectedClassDivisionStream.length > 0){
                setSelectedStudent([]);
                setSelectedBatch([]);
                setSelectedGroup([])
                setSelectedClassDivision([])
                const studentclassStreamMapping = selectedClassDivisionStream.map(item => ({
                    type: 'class-division',
                    classId: item.fkClassId,
                    className: item.fkClassName,
                    ...(item.fkDivisionId && item.fkDivisionName ? {
                        divisionId: item.fkDivisionId,
                        divisionName: item.fkDivisionName
                    }: {}),

                    ...(item.streamId && item.classStreamName ? {
                        streamId: item.streamId,
                        streamName: item.classStreamName
                    } : {})
                }))

                assignActivityObj.studentMappings = studentclassStreamMapping;

            }

            const responseAssign = await assignLabQuestion(assignActivityObj);

            if (responseAssign.data.statusCode === 200) {
                setButtonText("Done");
                const currentDate = new Date();
                const formattedDate = currentDate.toLocaleDateString('en-US', {
                    month: 'numeric',
                    day: 'numeric',
                    year: 'numeric',
                });
                values.createdDate = formattedDate;
                values.totalAssignedCount = responseAssign.data.totalAssignedCount;
                values.labQuestionsMappingId = responseAssign.data.activity_mapping_id;

                if (!values.questionTitle && !values.aiQuestionTitle) {
                    values.questionTitle = selectedCurentQuestion.title;
                }
                if (!values.projectType && !aiProjectType) {
                    values.projectType = selectedCurentQuestion.projectType;
                }
                if (!values._id) {
                    values._id = selectedCurentQuestion._id;
                }
                if (!values.elements) {
                    values.elements = selectedCurentQuestion.elements;
                }
                // if (!values.maximumMark) {
                //     selectedCurentQuestion.elements.forEach(obj => {
                //         if (obj.value && obj.value.mark && obj.value.mark.totalMark) {
                //             values.maximumMark = obj.value.mark.totalMark;
                //         }
                //     });
                // }

                if (selectedStudent && selectedStudent.length > 0) {
                    values.assignTo = [
                        {
                            "type": "individual-students",
                            "individualStudents": selectedStudent
                        }
                    ]
                }
                if (selectedBatch && selectedBatch.length > 0) {
                    values.assignTo = [
                        {
                            "type": "batches",
                            "batches": selectedBatch
                        }
                    ]
                }
                if (selectedGroup && selectedGroup.length > 0) {
                    values.assignTo = [
                        {
                            "type": "groups",
                            "groups": selectedGroup
                        }
                    ]
                }
                if (selectedClassDivision && selectedClassDivision.length > 0) {
                    values.assignTo = selectedClassDivision.map((item) => {
                        const classDivisionObj = {
                            type: "class-division",
                            classId: item.fkClassId,
                            className: item.fkClassName,
                        };

                        if (item.fkDivisionId) {
                            classDivisionObj.divisionId = item.fkDivisionId;
                            classDivisionObj.divisionName = item.fkDivisionName;
                        }

                        if (item.streamId) {
                            classDivisionObj.streamId = item.streamId;
                            classDivisionObj.streamName = item.streamName;
                        }

                        return classDivisionObj;
                    });
                }

                if(selectedClassDivisionStream && selectedClassDivisionStream.length > 0){
                    values.assignTo = selectedClassDivisionStream.map((item) => {
                        const  classDivisionStream = {
                            type: "class-division",
                            classId: item.fkClassId,
                            className: item.fkClassName,
                        };

                        if (item.fkDivisionId) {
                            classDivisionStream.divisionId = item.fkDivisionId;
                            classDivisionStream.divisionName = item.fkDivisionName;
                        }

                        if (item.streamId) {
                            classDivisionStream.streamId = item.streamId;
                            classDivisionStream.streamName = item.streamName;
                        }

                        return classDivisionStream
                    })
                }


                setButtonLoader(false);
                notification.success({
                    message: 'Success',
                    description: "Successfully assigned lab question",
                });
                onCreate(values, 'create');
            } else {
                setButtonText("Assign");
                setButtonLoader(false);
                notification.error({
                    message: 'Error',
                    description: responseAssign.data.message,
                });
            }
        } catch (error) {
            setButtonText("Assign");
            setButtonLoader(false);
            console.error("Error during service request:", error);
            notification.error({
                message: 'Error',
                description: 'An error occurred during the service request.',
            });
        }
    };

    const onFinish = async (values) => {
        setButtonText("Creating Lab Question...");
        setButtonLoader(true);
        if (
            (!selectedBatch || selectedBatch.length === 0) &&
            (!selectedStudent || selectedStudent.length === 0) &&
            (!selectedClassDivision || selectedClassDivision.length === 0) &&
            (!selectedGroup || selectedGroup.length === 0) &&
            (!selectedClassDivisionStream || selectedClassDivisionStream.length === 0)
        ) {
            // Handle the case where none of the assignment methods are selected
            notification.error({
                message: "Error",
                description: "Choose at least one class, division, stream, student, batch, or group, and click '+ Add' to assign it",
            });
            setButtonText("Assign");
            setButtonLoader(false);
            return
        }

        if (activeTabKey === 'createNewQuestion') {
            trackEvent("create_new_lab_assignment_question_button_clicked", {});
            // Logic for creating a new question
            let elements = [];
            let questionArray = [];

            const resourceObj = {
                "companyId": global_var.company_id,
                "fkUserLoginId": global_var.user_login_id,
                "Name": "Lab question",
                "projectType": values.projectType,
                "Icon": "fa-laptop",
                "iconBackground": "rgb(255, 17, 0)",
                "iconColor": "#ffffff",
                "evaluable": true,
                "hideResourse": false,
                "title": values.questionTitle,
                "subjectId": "5903134e6e5694e0619fc82d",  // Directly set to subject CS lab
                "subjectName": "Computer Science",
                "activeFlag": 1,
            }
            if (selectedLevel?._id) {
                resourceObj.resourceStudentLevelName = selectedLevel.resourceStudentLevelName;
                resourceObj.resourceStudentLevelColor = selectedLevel.resourceStudentLevelColor;
                resourceObj.fkResourceStudentLevelId = selectedLevel._id;
            }
            //hard coded sub subject based on project type
            if (values.projectType === 'python') {
                resourceObj.subSubjectName = "Python";
                resourceObj.subSubjectId = "5c0ef9129b0452781408b30f";
            }
            if (values.projectType === 'html_css') {
                resourceObj.subSubjectName = "HTML";
                resourceObj.subSubjectId = "5c0efaa29b0452781008b30b";
            }
            if (values.projectType === 'vc3') {
                resourceObj.subSubjectName = "Visual Coding";
                resourceObj.subSubjectId = "65953a8aee6426264537307c";

            }
            if (values.projectType === 'sql2') {
                resourceObj.subSubjectName = "SQL";
                resourceObj.subSubjectId = "65953a2aee6426264537307b";

            }

            if (values.maximumMark && values.maximumMark > 0) {
                resourceObj.totalMark = values.maximumMark;
            }

            questionArray.push({
                "type": "text",
                "question": questionDescription
            })
            if (image.length > 0) {
                questionArray.push(...image);
            }
            if (audio.length > 0) {
                questionArray.push(...audio);
            }
            if (video.length > 0) {
                questionArray.push(...video);
            }

            elements.push({
                "displayName": "Title",
                "type": "cours-element-title",
                "value": values.questionTitle

            })
            elements.push({
                "displayName": "Lab question",
                "value": {
                    // "editorName": "tinyMCE",
                    "mark": {
                        "totalMark": values.maximumMark
                    },
                    "type": "descriptive",
                    "question": questionArray,
                    "ques":questionDescription
                }

            })
            resourceObj.elements = elements;
            values.elements = elements;
            // Trigger the parent component's onCreate function
            //service call

            let requestObj = {
                resourceData: resourceObj,
                rmId: global_var.roleMappingId
            }

            try {
                const response = await saveMaterialToResource(requestObj);
                const responseData = JSON.parse(response.data);
                if (responseData.statuscode === 200 && responseData.resourceRes._id['$oid']) {
                    setButtonText("Assigning Lab Question...");
                    let selectedLabQuestions = [
                        {
                            "fkActivityId": responseData.resourceRes._id['$oid'],
                            "activityName": responseData.resourceRes.title,
                            'projectType' : values.projectType
                        }
                    ]
                    values._id = responseData.resourceRes._id['$oid'];
                    await assignLabQuestions(selectedLabQuestions, values);

                } else {
                    setButtonText("Assign");
                    setButtonLoader(false);
                    notification.error({
                        message: 'Error',
                        description: responseData.message,
                    });
                }
            } catch (error) {
                setButtonText("Assign");
                setButtonLoader(false);
                console.error("Error during service request:", error);
                notification.error({
                    message: 'Error',
                    description: 'An error occurred during the service request.',
                });
            }
        } else if (activeTabKey === 'pickExistingQuestion') {
            // Logic for assigning an existing question
            trackEvent("assign_existing_lab_assignment_question_button_clicked", {});
            if (selectedLabQuestions.length === 0) {
                setButtonText("Assign");
                setButtonLoader(false);
                notification.error({
                    message: 'Error',
                    description: 'Please select at least one existing question to assign.',
                });
                return;
            } else {
                await assignLabQuestions(selectedLabQuestions, values);
            }
        } else if (activeTabKey === 'aiquestions') {

            if (aiProjectType && !values.projectType) {
                values.projectType = aiProjectType
            }

            let elements = [];
            let questionArray = [];

            const resourceObj = {
                "companyId": global_var.company_id,
                "fkUserLoginId": global_var.user_login_id,
                "Name": "Lab question",
                "projectType": values.projectType,
                "Icon": "fa-laptop",
                "iconBackground": "rgb(255, 17, 0)",
                "iconColor": "#ffffff",
                "evaluable": true,
                "hideResourse": false,
                "title": values.aiQuestionTitle,
                "subjectId": "5903134e6e5694e0619fc82d",  // Directly set to subject CS lab
                "subjectName": "Computer Science",
                "activeFlag": 1,
            }
            if (selectedLevel?._id) {
                resourceObj.resourceStudentLevelName = selectedLevel.resourceStudentLevelName;
                resourceObj.resourceStudentLevelColor = selectedLevel.resourceStudentLevelColor;
                resourceObj.fkResourceStudentLevelId = selectedLevel._id;
            }
            //hard coded sub subject based on project type
            if (aiProjectType === 'python') {
                resourceObj.subSubjectName = "Python";
                resourceObj.subSubjectId = "5c0ef9129b0452781408b30f";
            }
            if (aiProjectType === 'html_css') {
                resourceObj.subSubjectName = "HTML";
                resourceObj.subSubjectId = "5c0efaa29b0452781008b30b";
            }
            if (aiProjectType === 'vc3') {
                resourceObj.subSubjectName = "Visual Coding";
                resourceObj.subSubjectId = "65953a8aee6426264537307c";

            }
            if (aiProjectType === 'sql2') {
                resourceObj.subSubjectName = "SQL";
                resourceObj.subSubjectId = "65953a2aee6426264537307b";

            }

            if (values.aiMaximumMark && values.aiMaximumMark > 0) {
                resourceObj.totalMark = values.aiMaximumMark;
            }

            questionArray.push({
                "type": "text",
                "question": aiQuestionDescriptions
            })
            if (image.length > 0) {
                questionArray.push(...image);
            }
            if (audio.length > 0) {
                questionArray.push(...audio);
            }
            if (video.length > 0) {
                questionArray.push(...video);
            }

            elements.push({
                "displayName": "Title",
                "type": "cours-element-title",
                "value": values.aiQuestionTitle

            })
            elements.push({
                "displayName": "Lab question",
                "value": {
                    // "editorName": "tinyMCE",
                    "mark": {
                        "totalMark": values.aiMaximumMark
                    },
                    "type": "descriptive",
                    "question": questionArray,
                    "ques":aiQuestionDescriptions
                }

            })
            resourceObj.elements = elements;
            values.elements = elements;
            // Trigger the parent component's onCreate function
            //service call

            let requestObj = {
                resourceData: resourceObj,
                rmId: global_var.roleMappingId
            }

            try {
                const response = await saveMaterialToResource(requestObj);
                const responseData = JSON.parse(response.data);
                if (responseData.statuscode === 200 && responseData.resourceRes._id['$oid']) {
                    setButtonText("Assigning Lab Question...");
                    let selectedLabQuestions = [
                        {
                            "fkActivityId": responseData.resourceRes._id['$oid'],
                            "activityName": responseData.resourceRes.title,
                            'projectType' : values.projectType
                        }
                    ]
                    values._id = responseData.resourceRes._id['$oid'];
                    await assignLabQuestions(selectedLabQuestions, values);

                } else {
                    setButtonText("Assign");
                    setButtonLoader(false);
                    notification.error({
                        message: 'Error',
                        description: responseData.message,
                    });
                }
            } catch (error) {
                setButtonText("Assign");
                setButtonLoader(false);
                console.error("Error during service request:", error);
                notification.error({
                    message: 'Error',
                    description: 'An error occurred during the service request.',
                });
            }
        }
    };

    const renderAssignToSection = () => {
        switch (assignTo) {

            case 'ClassDivisions':
                return (
                    <>
                        <Col span={12}>
                            <ClassDivisionLoader onChange={addClassDivision} selectedClassDivision={selectedClassDivision} isMultiple={true} onRemoveClassDivisions={removeClassDivision}/>
                        </Col>
                        <Col span={18} className="mt-2">
                            <Row>
                                {selectedClassDivision.map((cd, index) => (
                                    <div key={index} className='tagContainer' style={{marginRight: '5px', marginBottom: '8px'}}>
                                        <span style={{ marginRight: '8px' }}>  {`${cd.fkClassName}${cd.fkDivisionName ? `-${cd.fkDivisionName}` : ''}`}</span>
                                        <CloseOutlined onClick={() => removeClassDivision(cd.fkDivisionId)} className='closeIcon' />
                                    </div>
                                ))}
                            </Row>
                        </Col>
                    </>
                );
            case 'Stream':
                return (

                    <>
                        <Row>
                            <Col span={12}>
                                <ClassDivisionLoader onChange={handleClassDivision} />
                            </Col>
                            <Col span={12}>
                                <StreamLoader  onChange={handleStreamChange}  classDivision={singleClassDivisionStream ? singleClassDivisionStream : null}/>
                            </Col>
                        </Row>
                        <Row className='mt-2 mb-3'>
                            <span className='warning-msg'>Select class,division,category and stream then click 'Add Stream' to add it</span>
                        </Row>

                        <Button className='mr-2 mt-2 mb-3 cancel-button'
                            style={{ display: 'inline-flex', verticalAlign: 'middle', cursor: 'pointer'}}
                            onClick={addClassDivisionStream}
                        >
                            + Add Stream
                        </Button>

                        <Col span={18} className="mt-2">
                            <Row>
                                {selectedClassDivisionStream.map((cd, index) => (
                                    <div key={index} className='tagContainer' style={{marginRight: '5px', marginBottom: '8px'}}>
                                        <span className='label'><label>{`${cd.fkClassName}${cd.fkDivisionName ? `${cd.fkDivisionName}` : ''}`}</label>{`${cd.classStreamName ? `- ${cd.classStreamName}` : ''}`}</span>
                                        <CloseOutlined onClick={() => removeClassDivisionStream(index)} className='closeIcon' />
                                    </div>
                                ))}
                            </Row>
                        </Col>
                    </>

                );
            case 'Batches':
                return <BatchLoader onChange={handleBatchChange} />;
            case 'IndividualStudents':
                return <StudentLoader onChange={handleStudentChange} />;
            case 'Groups':
                return <GroupLoader onChange={handleGroupChange} />;
            default:
                return null;
        }
    };

    const handleDeleteImage = (index) => {
        const updatedImagePreview = [...imagePreview];
        updatedImagePreview.splice(index, 1);
        setImagePreview(updatedImagePreview);
        const updatedImage = [...image];
        updatedImage.splice(index, 1);
        setImage(updatedImage);

        const fileInputImage = document.querySelector('input[type="file"][accept="image/*"]');
        if (fileInputImage) {
            fileInputImage.value = '';
        }
    };

    const handleDeleteVideo = (index) => {
        const updatedVideoPreview = [...videoPreview];
        updatedVideoPreview.splice(index, 1);
        setVideoPreview(updatedVideoPreview);
        const updatedVideo = [...video];
        updatedVideo.splice(index, 1);
        setVideo(updatedVideo);

        const fileInputVideo = document.querySelector('input[type="file"][accept="video/*"]');
        if (fileInputVideo) {
            fileInputVideo.value = '';
        }
    };

    const handleDeleteAudio = (index) => {
        const updatedAudioPreview = [...audioPreview];
        updatedAudioPreview.splice(index, 1);
        setAudioPreview(updatedAudioPreview);
        const updatedAudio = [...audio];
        updatedAudio.splice(index, 1);
        setAudio(updatedAudio);

        const fileInput = document.querySelector('input[type="file"][accept="audio/*"]');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const handleEditorChange = (content) => {
        setQuestionDescription(content);
    };

    const handleAiEditorChange = (content) => {
        setAiQuestionDescriptions(content)
    };

    const handleParaphraseChange = (content) => {
        setParaphrasedDescription(content);
    }

    const handleFilterChange = async (selectedFilters) => {
        if (isEqual(selectedFilters, previousFilters)) {
            return;
        }
        try {
            let requestObj = {
                "companyId": global_var.company_id,
            };

            if (global_var.role_id !== '2') {
                requestObj['fkUserLoginId'] = global_var.user_login_id;
            }

            // Add searchText filter if available
            if (selectedFilters.searchText && selectedFilters.searchText.length > 0) {
                requestObj["searchText"] = selectedFilters.searchText;
            }

            if (selectedFilters.projectTypes && selectedFilters.projectTypes.length > 0) {
                requestObj["projectTypes"] = selectedFilters.projectTypes;
            }

            const response = await fetchLabQuestionResource(requestObj);
            if (response.data.statusCode === 200) {
                setLabQuestions(response.data.labQuestions);
            } else {
                console.error("Failed to fetch lab questions:", response.data.message);
            }
        } catch (error) {
            console.error("Error fetching lab questions:", error);
        }
        setPreviousFilters(selectedFilters);
    };

    const handleTabChange = async (key) => {
        setActiveTabKey(key);
    };

    useEffect(() => {
        // This code will run when the 'visible' prop changes
        setMoreOptionChecked(false);
        setDueDateChecked(false)
        setSelectedStudent([]);
        setSelectedLevel(null);
        setSelectedBatch([]);
        setSelectedGroup([]);
        setSelectedClassDivision([]);
        setSingleClassDivisionStream([])
        setSelectedClassDivisionStream([])
        setImage([]);
        setAudio([]);
        setImagePreview([]);
        setAudioPreview([]);
        setVideo([]);
        setVideoPreview([]);
        setAssignTo(null);
        setButtonText("Assign Now");
        setActiveTabKey("createNewQuestion");
        setSelectedProject('default');
        setGrade(null);
        setTopic('');
        setAdditionalInfo('');
        setQuestionDescription('')
        setAiQuestionDescriptions('')
        form.resetFields();
    }, [visible, form]);

    const addClassDivisionStream = () => {
        if (singleClassDivisionStream.fkClassId && singleClassDivisionStream.fkDivisionId && singleClassDivisionStream.streamId) {
            if (!selectedClassDivisionStream.some(
                    item => item.fkClassId === singleClassDivisionStream.fkClassId && item.fkDivisionId === singleClassDivisionStream.fkDivisionId &&
                    item.streamId === singleClassDivisionStream.streamId
                )) {
                // Add the singleClassDivisionStream to selectedClassDivisions
                setSelectedClassDivisionStream(prevClassDivisions => [...prevClassDivisions, singleClassDivisionStream]);
                setSelectedClassDivision([])
            }
        }
    }

    const removeClassDivisionStream = (index) => {
        setSelectedClassDivisionStream(prevClassDivisionStream => 
            prevClassDivisionStream.filter((_, i) => i !== index)
        );
    };

    const addClassDivision = (ClassDivision) => {
        if (ClassDivision.fkClassId && ClassDivision.fkDivisionId) {
            if (!selectedClassDivision.some(
                item => item.fkClassId === ClassDivision.fkClassId && item.fkDivisionId === ClassDivision.fkDivisionId)) {
                // Add the ClassDivision to selectedClassDivisions
                setSelectedClassDivision(prevClassDivisions => [...prevClassDivisions, ClassDivision]);
                setSelectedClassDivisionStream([])
            }
        }
    }

    const removeClassDivision = (divisionId) => {
        setSelectedClassDivision(prevClassDivisions => 
          prevClassDivisions.filter((_, i) => _.fkDivisionId !== divisionId)
        );
    };

    const handleAiQuestionData = (values) => {
        const newValues = {
            aiQuestionTitle: values.questionTitle || formValues.aiQuestionTitle,
            aiQuestionDescription: values.question || formValues.aiQuestionDescription
        };

        setFormValues(newValues);
        form.setFieldsValue(newValues);
        if (values.aiProjectType) {
            setAiProjectType(values.aiProjectType)
        }
    };

    useEffect(() => {
        form.setFieldsValue(formValues);
    }, [formValues, form]);
    const [paraphraseVisible, setParaphraseVisible] = useState(false);

  const showModal = () => {
    setParaphraseVisible(true);
  };

  const handleClose = () => {
    setParaphraseVisible(false);
  };

  const handleAssignToChange = (value) => {
    setAssignTo(value);
    if (value !== 'ClassDivisions') {
        setSelectedClassDivision([]);
    }
};

    return (
        <Modal
            className='poppins-bold'
            visible={visible}
            title="Assign Lab Question"
            onCancel={onCancel}
            footer={[
                // <Button key="cancel" onClick={onCancel}>
                //     Cancel
                // </Button>,
                <Button
                    key="ok"
                    type="primary"
                    loading={buttonLoader}
                    onClick={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                // Set loading to true when the button is clicked
                                onFinish(values);
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });
                    }}
                >
                    {buttonText}
                </Button>,
            ]}
            style={{ backgroundColor: '#ffffff' }}
            width={'60%'}
        >
            <Form form={form} name="form_in_modal" onFinish={onFinish} layout="vertical">
                <Tabs activeKey={activeTabKey} onChange={handleTabChange} className='custom-tabs poppins-medium' type="card">
                    <TabPane tab="Create New Question" key="createNewQuestion">
                        <Form.Item className='poppins-regular'
                            name="questionTitle"
                            labelCol={{ className: 'poppins-regular' }}
                            label="Question Title"
                            rules={
                                activeTabKey === 'createNewQuestion'
                                    ? [{ required: true, message: 'Please enter the Question Title' }]
                                    : []
                            }
                        >
                            <Input placeholder="Type the assignment title here. Eg, Lab Question 1" style={{width:'60%'}}/>
                        </Form.Item>

                        <Form.Item
                            name="questionDescription"
                            label="Question Description"
                            labelCol={{ className: 'poppins-regular' }}
                        >
                            {/* <Input.TextArea rows={4} /> */}
                            <TinyMCEEditor 
                                onEditorChange={handleEditorChange}
                                initialValue={paraphrasedDescription}
                                >
                            </TinyMCEEditor>
                            
                            {/* <Button class="paraphrase-button" >ddsdsd</Button> */}

                        </Form.Item>
                        { questionDescription && <div className='paraphrase-btn-container'>
                            <Tooltip title='Paraphrase'>
                                <button className="paraphrase-button" onClick={showModal}>
                                    <AiIconWhite width="15px" height="15px" />
                                </button>
                            </Tooltip>
                            <ParaphraseAi visible={paraphraseVisible}  handleParaphraseChange={handleParaphraseChange} questionDescription={questionDescription} onClose={handleClose} />
                        </div>

                        }
                        
                        
                        <Row >
                            <Form.Item
                                name="projectType"
                                label="Project Type"
                                labelCol={{ className: 'poppins-regular' }}
                                rules={
                                    activeTabKey === 'createNewQuestion'
                                        ? [{ required: true, message: 'Please select a project type' }]
                                        : []
                                }
                            >
                                <Select defaultValue="default" >
                                    <Option value="default" disabled>
                                        Select a project type
                                    </Option>
                                    {Object.values(projectStacks)
                                        .flatMap((items) =>
                                            items
                                                .map((item) => ({
                                                    ...item,
                                                    metaData: getIdeProjectTypeMetaData(item.projectStackName),
                                                }))
                                                .filter((item) => item.metaData.showLabQuestion)
                                        )
                                        .map((item) => (
                                            <Option key={item.projectStackName} value={item.projectStackName}>
                                                {item.metaData.projectStackDisplayName}
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                className='mx-2'
                                name="maximumMark"
                                label="Maximum Marks"
                                labelCol={{ className: 'poppins-regular' }}
                                rules={[
                                    {
                                        validator: async (_, value) => {
                                            if (value < 1) {
                                                throw new Error('Please enter a valid mark');
                                            }
                                        },
                                        message: 'Please enter a valid mark',
                                    },
                                ]}
                            >
                                <InputNumber 
                                    min={0}
                                    onKeyDown={(event) => {
                                        if (!/[0-9]/.test(event.key) && event.key !== "Backspace") {
                                            event.preventDefault(); // Blocks non-numeric input
                                        }
                                    }}
                                placeholder='Enter mark'style={{width:'150px' }}/>
                            </Form.Item>
                        </Row>
                        <Row className="mb-2">
                            <Form.Item name="image">
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, 'image')} style={{ display: 'none' }} />
                                <Button className='mr-2 cancel-button'
                                    icon={<FileImageOutlined style={{ verticalAlign: '-webkit-baseline-middle', marginBottom: '10px' }} />}
                                    style={{ display: 'inline-block', verticalAlign: 'middle' }}
                                    onClick={() => document.querySelector('input[type="file"][accept="image/*"]').click()}
                                >
                                    Attach Images
                                </Button>
                                {/* Render image preview */}
                                {imageLoading ? (
                                    <Spin />
                                ) : (
                                    imagePreview && (
                                        <div>
                                            {imagePreview.map((preview, index) => (
                                                <div key={index} className='img-thumbnail-container' style={{ position: 'relative', display: 'inline-block' }}>
                                                    <Image
                                                        className='img-thumbnail'
                                                        src={preview.preview}
                                                        alt={`Preview ${index}`}
                                                        style={{ width: '150px', height: '150px', objectFit: 'cover', margin: '10px' }}
                                                    />
                                                    <Popconfirm
                                                        title="Are you sure to delete this image?"
                                                        onConfirm={() => handleDeleteImage(index)}
                                                        okText="Yes"
                                                        cancelText="No"
                                                        placement="bottomRight"
                                                        overlayStyle={{ width: 'max-content' }} 
                                                    >
                                                        <DeleteOutlined style={{ top:'15px', position: 'absolute',  right: '15px', cursor: 'pointer', color: 'red', fontSize:'15px' }} />
                                                    </Popconfirm>
                                                </div>
                                            ))}
                                        </div>
                                    )
                                )}


                            </Form.Item>
                            <Form.Item name="audio">
                                <input type="file" accept="audio/*" onChange={(e) => handleFileChange(e, 'audio')} style={{ display: 'none' }} />
                                <Button className='cancel-button'
                                    icon={<AudioOutlined style={{ verticalAlign: '-webkit-baseline-middle', marginBottom: '10px' }} />}
                                    style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: '8px' }}
                                    onClick={() => document.querySelector('input[type="file"][accept="audio/*"]').click()}
                                >
                                    Attach Audio
                                </Button>
                                {/* Render audio preview */}
                                {audioLoading ? (
                                    <Spin />
                                ) : (
                                    audioPreview && (
                                        <div>
                                            {audioPreview.map((preview, index) => (
                                            <div key={index} className='img-thumbnail-container' style={{ position: 'relative', display: 'inline-block',border:'1px solid #f4f4f4',top:'5px' }}>
                                                 
                                                <audio controls style={{ marginLeft: '8px', marginTop: '2px' }}>
                                                    <source src={preview.preview} type="audio/mpeg" />
                                                    Your browser does not support the audio element.
                                                </audio>
                                                <Popconfirm
                                                    title="Are you sure to delete this audio?"
                                                    onConfirm={() => handleDeleteAudio(index)}
                                                    okText="Yes"
                                                    cancelText="No"
                                                    placement="bottomRight"
                                                    overlayStyle={{ width: 'max-content' }} 
                                                >
                                                <Tooltip title='Delete' >
                                                    <DeleteOutlined style={{top:'5px', position: 'absolute',  right: '5px', cursor: 'pointer', color: 'red', fontSize:'20px' }} />
                                                </Tooltip>
                                                </Popconfirm>
                                            </div>
                                            ))}
                                        </div>
                                    )
                                )}

                            </Form.Item>

                            <Form.Item name="video">
                                <input type="file" accept="video/*" onChange={(e) => handleFileChange(e, 'video')} style={{ display: 'none' }} />
                                <Button className='cancel-button'
                                    icon={<VideoCameraOutlined style={{ verticalAlign: '-webkit-baseline-middle', marginBottom: '10px' }} />}
                                    style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: '8px' }}
                                    onClick={() => document.querySelector('input[type="file"][accept="video/*"]').click()}
                                >
                                    Attach Video
                                </Button>
                                {/* Render video preview */}
                                {videoLoading ? (
                                    <Spin />
                                ) : (
                                    videoPreview && (
                                        <div>
                                             {videoPreview.map((preview, index) => (
                                                <div key={index} className='img-thumbnail-container' style={{ position: 'relative', display: 'inline-block',border:'1px solid #f4f4f4',top:'5px' }}>
                                                 
                                                    <video width="320" height="240" controls>
                                                        <source src={preview.preview} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                    <Popconfirm
                                                        title="Are you sure to delete this video?"
                                                        onConfirm={() => handleDeleteVideo(index)}
                                                        okText="Yes"
                                                        cancelText="No"
                                                        placement="bottomRight"
                                                        overlayStyle={{ width: 'max-content' }} 
                                                    >
                                                    <Tooltip title='Delete' >
                                                        <DeleteOutlined style={{top:'5px', position: 'absolute',  right: '5px', cursor: 'pointer', color: 'red', fontSize:'20px' }} />
                                                    </Tooltip>
                                                    </Popconfirm>
                                                </div>
                                            ))}
                                        </div>
                                    )
                                )}
                            </Form.Item>

                        </Row>
                        <Form.Item name="moreOption" className='mb-2' valuePropName="checked">
                            <Checkbox id="moreOptionCheckbox" className='mr-2' onChange={handleMoreOptionChange} />
                            <label className='poppins-medium' style={{textDecoration:'underline',}} htmlFor="moreOptionCheckbox">More Options</label>
                        </Form.Item>
                        {moreOptionChecked && (
                            <Row className="mb-2">
                                {/* <Col span={11} style={{ marginRight: "8px" }}>
                             <Form.Item name="topic">
                                 <Select defaultValue="default" style={{ width: '100%' }}>
                                     <Option value="default" disabled>Topic</Option>
                                     <Option value="Topic1">Topic1</Option>
                                     <Option value="Topic2">Topic2</Option>
                                     <Option value="Topic3">Topic3</Option>
                                 </Select>
                             </Form.Item>
                         </Col> */}
                                <Col span={11}>
                                    <Form.Item name="studentLevel">
                                        <ResourceLevel onChange={handleResourceLevelChange}></ResourceLevel>
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                        <Divider className='mt-0 mb-2' style={{backgroundColor:"#D7BEF7"}}/>
                    </TabPane>

                    <TabPane key="aiquestions"
                        tab={
                            <span>
                                Ai Question
                                <AiIconRed />
                            </span>
                        }
                    >
                        <AiQuestions
                            handleAiQuestionData={handleAiQuestionData}
                            selectedProject={selectedProject}
                            grade={grade}
                            topic={topic}
                            additionalInfo={additionalInfo}
                            setSelectedProject={setSelectedProject}
                            setGrade={setGrade}
                            setTopic={setTopic}
                            setAdditionalInfo={setAdditionalInfo}
                        />

                        <Form.Item className='poppins-regular'
                            name="aiQuestionTitle"
                            labelCol={{ className: 'poppins-regular' }}
                            label="Question Title"
                            rules={
                                activeTabKey === 'aiquestions'
                                    ? [{ required: true, message: 'Please enter the Question Title' }]
                                    : []
                            }
                        >
                            <Input placeholder="Type the assignment title here. Eg, Lab Question 1" style={{width:'60%'}}/>
                        </Form.Item>

                        <Form.Item
                            name="aiQuestionDescription"
                            label="Question Description"
                            labelCol={{ className: 'poppins-regular' }}
                        >
                            {/* <Input.TextArea rows={4} /> */}
                            <TinyMCEEditor 
                                onEditorChange={handleAiEditorChange}
                                initialValue={form.getFieldValue('aiQuestionDescription') || ''}
                                >
                            </TinyMCEEditor>

                        </Form.Item>
                        <Row >
                            
                            <Form.Item
                                className='mx-2'
                                name="aiMaximumMark"
                                label="Maximum Marks"
                                labelCol={{ className: 'poppins-regular' }}
                                rules={[
                                    {
                                        
                                        validator: async (_, value) => {
                                            if (value < 1) {
                                                throw new Error('Please enter a valid mark');
                                            }
                                        },
                                        message: 'Please enter a valid mark',
                                    }
                                ]}
                            >
                                <InputNumber 
                                    placeholder='Enter mark'style={{width:'150px' }}
                                    min={0}
                                    onKeyDown={(event) => {
                                        if (!/[0-9]/.test(event.key) && event.key !== "Backspace") {
                                            event.preventDefault(); // Blocks non-numeric input
                                        }
                                    }}    
                                />
                            </Form.Item>
                        </Row>
                        <Row className="mb-2">
                            <Form.Item name="aiImage">
                                <input id='aiQuestionImage' type="file" accept="image/*" onChange={(e) => handleFileChange(e, 'image')} style={{ display: 'none' }} />
                                <Button className='mr-2 cancel-button'
                                    icon={<FileImageOutlined style={{ verticalAlign: '-webkit-baseline-middle', marginBottom: '10px' }} />}
                                    style={{ display: 'inline-block', verticalAlign: 'middle' }}
                                    onClick={() => document.getElementById('aiQuestionImage').click()}
                                >
                                    Attach Images
                                </Button>
                                {/* Render image preview */}
                                {imageLoading ? (
                                    <Spin />
                                ) : (
                                    imagePreview && (
                                        <div>
                                            {imagePreview.map((preview, index) => (
                                                <div key={index} className='img-thumbnail-container' style={{ position: 'relative', display: 'inline-block' }}>
                                                    <Image
                                                        className='img-thumbnail'
                                                        src={preview.preview}
                                                        alt={`Preview ${index}`}
                                                        style={{ width: '150px', height: '150px', objectFit: 'cover', margin: '10px' }}
                                                    />
                                                    <Popconfirm
                                                        title="Are you sure to delete this image?"
                                                        onConfirm={() => handleDeleteImage(index)}
                                                        okText="Yes"
                                                        cancelText="No"
                                                        placement="bottomRight"
                                                        overlayStyle={{ width: 'max-content' }} 
                                                    >
                                                        <DeleteOutlined style={{ top:'15px', position: 'absolute',  right: '15px', cursor: 'pointer', color: 'red', fontSize:'15px' }} />
                                                    </Popconfirm>
                                                </div>
                                            ))}
                                        </div>
                                    )
                                )}


                            </Form.Item>
                            <Form.Item name="aiAudio">
                                <input id="aiQuestionAudio" type="file" accept="audio/*" onChange={(e) => handleFileChange(e, 'audio')} style={{ display: 'none' }} />
                                <Button className='cancel-button'
                                    icon={<AudioOutlined style={{ verticalAlign: '-webkit-baseline-middle', marginBottom: '10px' }} />}
                                    style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: '8px' }}
                                    onClick={() => document.getElementById('aiQuestionAudio').click()}
                                >
                                    Attach Audio
                                </Button>
                                {/* Render audio preview */}
                                {audioLoading ? (
                                    <Spin />
                                ) : (
                                    audioPreview && (
                                        <div>
                                            {audioPreview.map((preview, index) => (
                                            <div key={index} className='img-thumbnail-container' style={{ position: 'relative', display: 'inline-block',border:'1px solid #f4f4f4',top:'5px' }}>
                                                 
                                                <audio controls style={{ marginLeft: '8px', marginTop: '2px' }}>
                                                    <source src={preview.preview} type="audio/mpeg" />
                                                    Your browser does not support the audio element.
                                                </audio>
                                                <Popconfirm
                                                    title="Are you sure to delete this audio?"
                                                    onConfirm={() => handleDeleteAudio(index)}
                                                    okText="Yes"
                                                    cancelText="No"
                                                    placement="bottomRight"
                                                    overlayStyle={{ width: 'max-content' }} 
                                                >
                                                <Tooltip title='Delete' >
                                                    <DeleteOutlined style={{top:'5px', position: 'absolute',  right: '5px', cursor: 'pointer', color: 'red', fontSize:'20px' }} />
                                                </Tooltip>
                                                </Popconfirm>
                                            </div>
                                            ))}
                                        </div>
                                    )
                                )}

                            </Form.Item>

                            <Form.Item name="aiVideo">
                                <input id='aiQuestionVideo' type="file" accept="video/*" onChange={(e) => handleFileChange(e, 'video')} style={{ display: 'none' }} />
                                <Button className='cancel-button'
                                    icon={<VideoCameraOutlined style={{ verticalAlign: '-webkit-baseline-middle', marginBottom: '10px' }} />}
                                    style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: '8px' }}
                                    onClick={() => document.getElementById('aiQuestionVideo').click()}
                                >
                                    Attach Video
                                </Button>
                                {/* Render video preview */}
                                {videoLoading ? (
                                    <Spin />
                                ) : (
                                    videoPreview && (
                                        <div>
                                             {videoPreview.map((preview, index) => (
                                                <div key={index} className='img-thumbnail-container' style={{ position: 'relative', display: 'inline-block',border:'1px solid #f4f4f4',top:'5px' }}>
                                                 
                                                    <video width="320" height="240" controls>
                                                        <source src={preview.preview} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                    <Popconfirm
                                                        title="Are you sure to delete this video?"
                                                        onConfirm={() => handleDeleteVideo(index)}
                                                        okText="Yes"
                                                        cancelText="No"
                                                        placement="bottomRight"
                                                        overlayStyle={{ width: 'max-content' }} 
                                                    >
                                                    <Tooltip title='Delete' >
                                                        <DeleteOutlined style={{top:'5px', position: 'absolute',  right: '5px', cursor: 'pointer', color: 'red', fontSize:'20px' }} />
                                                    </Tooltip>
                                                    </Popconfirm>
                                                </div>
                                            ))}
                                        </div>
                                    )
                                )}
                            </Form.Item>

                        </Row>
                        <Form.Item name="aiMoreOption" className='mb-2' valuePropName="checked">
                            <Checkbox id="moreOptionCheckbox" className='mr-2' onChange={handleMoreOptionChange} />
                            <label className='poppins-medium' style={{textDecoration:'underline',}} htmlFor="moreOptionCheckbox">More Options</label>
                        </Form.Item>
                        {moreOptionChecked && (
                            <Row className="mb-2">
                                <Col span={11}>
                                    <Form.Item name="studentLevel">
                                        <ResourceLevel onChange={handleResourceLevelChange}></ResourceLevel>
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                        <Divider className='mt-0 mb-2' style={{backgroundColor:"#D7BEF7"}}/>
                    </TabPane>
                    <TabPane tab="Pick From Existing Question" key="pickExistingQuestion">
                        {/* Render the content for the second tab (blank area) */}
                        <LabQuestionFilter onChange={handleFilterChange} />
                        <Divider />

                        <Table
                            className='mb-4 poppins-regular'
                            columns={columns}
                            dataSource={labQuestions}
                            pagination={{
                                pageSize: 5,
                                className:'cs-pagination', 
                            }}
                        />
                    </TabPane>
                </Tabs>
                <Form.Item name="assignOption" label="Assign to:" labelCol={{ className: 'poppins-medium' }}>
                    <Radio.Group onChange={(e) => handleAssignToChange(e.target.value)} value={assignTo} 
                    >  
                        {!hideClassFilter && (
                            <>
                                <Radio className='poppins-regular' value="ClassDivisions">Class divisions</Radio>
                                {!hideStreamFilter && (
                                    <Radio className='poppins-regular' value="Stream">Stream</Radio>
                                )}
                                <Radio className='poppins-regular' value="Groups">Groups</Radio>
                            </>
                        )}
                        <Radio className='poppins-regular' value="Batches">Batches</Radio>
                        <Radio className='poppins-regular' value="IndividualStudents">Individual students</Radio>
                    </Radio.Group>
                </Form.Item>
                {renderAssignToSection()}
                
                <Form.Item name="dueDate" className='mb-2' valuePropName="checked">
                    <Checkbox id="dueDateCheckbox" className='mr-2' onChange={handleDueDateChange} />
                    <label className='poppins-medium' style={{textDecoration:'underline',}} htmlFor="dueDateCheckbox">Choose a due date</label>
                </Form.Item>
                {dueDateChecked && (
                    <Row className="mb-2">
                        <Col span={11}>
                            <Form.Item name="dueDate">
                                <DatePicker
                                    onChange={handleDatePickerChange}
                                    disabledDate={disabledDate}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                )}
            </Form>
        </Modal>
    );
};

export default CreateAssignment;

